import { useApolloClient } from '@common/hooks';
import { useCallback } from 'react';

export const useApolloClientRefetch = () => {
  const client = useApolloClient();

  return useCallback(
    (refetchQueries: string[]) => {
      client.refetchQueries({
        include: refetchQueries,
      });
    },
    [client]
  );
};
